// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"984a0a44","84":"ada669bc","234":"036ddcc2","367":"c4ae6fef","605":"04e8d52c","678":"bb503ef3","776":"9c5db387","845":"2826c495"}[chunkId] + ".chunk.css";
};